import { __decorate, __extends } from "tslib";
import { inject, observer } from 'mobx-react';
import React from 'react';
import Dropzone from 'react-dropzone-uploader';
import { EndPoints, getAuthHeader, getBaseUrl, UploadType } from '../../api';
import { list } from '../../api/medias';
import { MediaItem } from '../../components/MediaItem';
import { SpinnerBlock } from '../../components/Spinner';
import S from './medias.styl';
var MediasView = /** @class */ (function (_super) {
    __extends(MediasView, _super);
    function MediasView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            medias: [],
            loading: false,
        };
        _this.dropZone = null;
        _this.onUpdate = function () {
            _this.fetchData();
        };
        _this.getUploadParams = function (_) {
            return {
                url: getBaseUrl() + EndPoints.upload + '?type=' + UploadType.generic,
                headers: getAuthHeader(),
            };
        };
        _this.handleChangeStatus = function (_, status) {
            if (status === 'done') {
                _this.fetchData();
                _this.dropZone.files = [];
            }
        };
        return _this;
    }
    MediasView.prototype.componentDidMount = function () {
        var store = this.props.store;
        if (store) {
            this.fetchData();
        }
    };
    MediasView.prototype.fetchData = function () {
        var _this = this;
        this.setState({ loading: true });
        list().then(function (result) {
            _this.setState({
                loading: false,
                medias: (result === null || result === void 0 ? void 0 : result.items) || [],
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    MediasView.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var i18n = props.store.i18n;
        var _a = this.state, loading = _a.loading, medias = _a.medias;
        return (React.createElement("div", { className: S.mediasView },
            React.createElement("h1", { className: S.mediasTitle }, i18n.mediasTitle),
            React.createElement("hr", { className: S.mediasSeparator }),
            React.createElement("div", { className: S.mediasHeaderActions },
                React.createElement(Dropzone, { ref: function (r) { return _this.dropZone = r; }, getUploadParams: this.getUploadParams, onChangeStatus: this.handleChangeStatus, multiple: false, inputContent: i18n.inputUploaderPlaceholder, canRestart: true, canCancel: false, canRemove: false, accept: "image/*" })),
            React.createElement("div", { className: S.mediasMainBox }, loading ?
                React.createElement(SpinnerBlock, null)
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: S.mediasHeader },
                            React.createElement("div", { className: S.tableCell }, i18n.mediasItemImage),
                            React.createElement("div", { className: S.tableCell + ' ' + S.image }, i18n.mediasItemUrl),
                            React.createElement("div", { className: S.action }, i18n.mediasAction)),
                        React.createElement("div", { className: S.mediasUserList }, medias.map(function (media, i) { return (React.createElement(MediaItem, { key: i, media: media, isUpdated: _this.onUpdate })); }))))));
    };
    MediasView = __decorate([
        inject('store'),
        observer
    ], MediasView);
    return MediasView;
}(React.Component));
export { MediasView };
